import React from 'react';
import { Notice } from './ui';

export default function FinishedPop() {
  return (
    <Notice tone="hinweis" title="Der Finanzierungszeitraum ist zu Ende">
      Spenden sind für dieses Projekt nicht mehr möglich. Updates kannst du
      weiterhin veröffentlichen.
    </Notice>
  );
}
